import { Plugin } from 'chart.js';

/** Draws a reliable vertical guide line for the main temperature chart. */
export const temperatureCrosshairPlugin: Plugin = {
  id: 'temperatureCrosshair',

  afterEvent(chart: any, args: any) {
    const event = args.event;
    const area = chart.chartArea;
    const x = event.x ?? event.native?.offsetX ?? event.nativeEvent?.offsetX;
    const y = event.y ?? event.native?.offsetY ?? event.nativeEvent?.offsetY;

    if (event.type === 'mouseout' || event.type === 'pointerout') {
      chart.$temperatureCrosshairX = undefined;
      args.changed = true;
      return;
    }

    if ((event.type === 'mousemove' || event.type === 'pointermove') && area &&
        x >= area.left && x <= area.right &&
        y >= area.top && y <= area.bottom) {
      chart.$temperatureCrosshairX = x;
      args.changed = true;
    }
  },

  afterDraw(chart: any) {
    const x = chart.$temperatureCrosshairX;
    const area = chart.chartArea;

    if (x === undefined || !area) {
      return;
    }

    const context = chart.ctx;
    context.save();
    context.beginPath();
    context.moveTo(x, area.top);
    context.lineTo(x, area.bottom);
    context.lineWidth = 1;
    context.strokeStyle = '#666';
    context.setLineDash([5, 5]);
    context.stroke();
    context.restore();
  }
};
